import { Injectable, InjectionToken, Provider } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PaginatedResponse } from '../../shared/pagination/paginated-response';
import { ApiPermission } from '../api-types/permission.api';
import { Permission } from '../app-types/permission.app';
import { transformApiPermissionsToAppPermissions } from '../transformers/permission.transform';
import { BaseRequestService } from './base-request.service';

export interface PermissionApiProvider {
	getAll(offset?: number, range?: number): Promise<PaginatedResponse<Permission>>;
}

export const PERMISSION_API_PROVIDER = new InjectionToken<PermissionApiProvider>('PERMISSION_API_PROVIDER');

@Injectable()
export class PermissionApiService extends BaseRequestService implements PermissionApiProvider {
	public getAll = async (offset?: number, range?: number) => {
		const result = await this.get<PaginatedResponse<ApiPermission>>('permissions', { offset, range });
		const entities = transformApiPermissionsToAppPermissions(result.entities);
		return {
			...result,
			entities,
		};
	};
}

@Injectable()
export class PermissionApiMockService implements PermissionApiProvider {
	public getAll = async (offset = 0, range = 500): Promise<PaginatedResponse<Permission>> => {
		return {
			entities: [],
			offset,
			range,
			totalEntities: 0,
		};
	};
}

export const providePermissionApiService: Provider = {
	provide: PERMISSION_API_PROVIDER,
	// Keep provider selection in one place so environments can switch between real and mock API.
	useClass: environment.useMockPermissions ? PermissionApiMockService : PermissionApiService,
};
